import { Toggle } from "@/components/Toggle";
import { Button } from "@/components/ui/Button";
import type { FeatureFlag } from "@/hooks/useFeatureFlag";
import useFeatureFlag from "@/hooks/useFeatureFlag";
import type React from "react";
import { Outlet, useNavigate } from "react-router-dom";

export function FeatureFlagGuard({
  flag,
  children,
}: {
  readonly flag: FeatureFlag;
  readonly children?: React.ReactNode;
}) {
  const { enabled } = useFeatureFlag(flag);
  const navigate = useNavigate();

  return (
    <Toggle
      off={
        <div className="flex size-full items-center justify-center gap-1">
          <p className="text-2xl font-bold">
            Es tut uns leid, aber dieses Feature ist nicht verfügbar.
          </p>
          <Button color="primary" onClick={() => navigate("/")}>
            Zurück zur Startseite
          </Button>
        </div>
      }
      on={children ?? <Outlet />}
      showOn={enabled}
    />
  );
}
